import React, { useState } from 'react';
import Sidebar from '../Sidebar';
import Header from '../Header';
import NotificationAffiliate from './NotificationAffiliate';

const NotificationAffiliateLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [openMenus, setOpenMenus] = useState({
    competitorResearch: false,
    messages: false,
    support: false,
    settings: false
  });
  const [notifications, setNotifications] = useState([
    { id: 1, type: 'success', title: 'Notification sent successfully', message: 'Email notification delivered to 45 affiliates', time: '2 min ago', unread: true },
    { id: 2, type: 'warning', title: 'Notification delivery failed', message: 'SMS notification failed for 3 affiliates', time: '1 hour ago', unread: true },
    { id: 3, type: 'info', title: 'Weekly notification report', message: 'Your notification performance report is ready', time: '3 hours ago', unread: false },
    { id: 4, type: 'success', title: 'Push notification delivered', message: 'Campaign update sent to 128 affiliates', time: '5 hours ago', unread: false }
  ]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [brands, setBrands] = useState([
    {
      id: 1,
      name: 'Zodiac Casino',
      url: 'https://zodiac.casino/',
      favicon: '/api/placeholder/24/24',
      vertical: 'Casino,Sports',
      healthScore: 1,
      estimatedTraffic: 809,
      liveAffiliates: 639,
      affiliateChange: 52,
      untappedOpportunities: 2844,
      opportunityChange: 156,
      country: 'CA'
    }
  ]);
  const [recentNotifications] = useState([
    {
      id: 1,
      recipient: 'Sarah Johnson',
      email: 'sarah.j@affiliatemax.com',
      brand: 'Zodiac Casino',
      lastSent: '2 hours ago',
      status: 'delivered',
      avatar: 'SJ',
      country: 'US',
      notificationType: 'Email',
      subject: 'New Campaign Launch'
    },
    {
      id: 2,
      recipient: 'Michael Chen',
      email: 'mchen@gamingpartners.net',
      brand: 'Sports Bet Pro',
      lastSent: '5 hours ago',
      status: 'pending',
      avatar: 'MC',
      country: 'CA',
      notificationType: 'SMS',
      subject: 'Commission Update'
    },
    {
      id: 3,
      recipient: 'Emma Rodriguez',
      email: 'emma@casinoaffs.com',
      brand: 'Lucky Slots',
      lastSent: '1 day ago',
      status: 'failed',
      avatar: 'ER',
      country: 'MX',
      notificationType: 'Push',
      subject: 'Payment Reminder'
    }
  ]);

  const [notificationsByCountry] = useState([
    { country: 'United States', code: 'US', count: 124, change: '+15%', deliveryRate: '94%' },
    { country: 'Canada', code: 'CA', count: 89, change: '+12%', deliveryRate: '97%' },
    { country: 'United Kingdom', code: 'GB', count: 76, change: '+18%', deliveryRate: '92%' },
    { country: 'Australia', code: 'AU', count: 54, change: '+9%', deliveryRate: '95%' },
    { country: 'Germany', code: 'DE', count: 43, change: '+6%', deliveryRate: '89%' }
  ]);

  const [currentUser] = useState({
    name: 'Vishnu',
    email: 'vishnu@company.com',
    plan: 'Enterprise User',
    avatar: 'VV',
    initials: 'VV'
  });

  const [dashboardStats] = useState({
    totalNotificationsSent: 1547,
    totalAffiliatesNotified: 438,
    averageDeliveryRate: 94.2,
    failedNotifications: 23
  });

  const [notificationTypes] = useState([
    {
      id: 1,
      type: 'Email',
      icon: '📧',
      totalSent: 892,
      deliveryRate: 96.5,
      avgResponseTime: '2.3 hours',
      status: 'active'
    },
    {
      id: 2,
      type: 'SMS',
      icon: '📱',
      totalSent: 423,
      deliveryRate: 98.2,
      avgResponseTime: '15 minutes',
      status: 'active'
    },
    {
      id: 3,
      type: 'Push',
      icon: '🔔',
      totalSent: 232,
      deliveryRate: 87.4,
      avgResponseTime: '45 minutes',
      status: 'active'
    },
    {
      id: 4,
      type: 'In-App',
      icon: '📲',
      totalSent: 156,
      deliveryRate: 91.8,
      avgResponseTime: '1.2 hours',
      status: 'active'
    },
    {
      id: 5,
      type: 'Webhook',
      icon: '🔗',
      totalSent: 89,
      deliveryRate: 99.1,
      avgResponseTime: '5 seconds',
      status: 'active'
    }
  ]);

  const [notificationTemplates] = useState([
    {
      id: 1,
      name: 'Welcome New Affiliate',
      type: 'Email',
      lastUsed: '2 days ago',
      usageCount: 45,
      category: 'Onboarding'
    },
    {
      id: 2,
      name: 'Commission Payment Alert',
      type: 'SMS',
      lastUsed: '5 hours ago',
      usageCount: 128,
      category: 'Financial'
    },
    {
      id: 3,
      name: 'Campaign Performance Update',
      type: 'Push',
      lastUsed: '1 day ago',
      usageCount: 76,
      category: 'Performance'
    },
    {
      id: 4,
      name: 'Policy Update Notification',
      type: 'In-App',
      lastUsed: '1 week ago',
      usageCount: 23,
      category: 'Compliance'
    }
  ]);

  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  return (
    <div className="min-h-screen transition-all duration-300 bg-gray-50 dark:bg-slate-950 text-sm">
      {/* Sidebar Component */}
      <Sidebar
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        openMenus={openMenus}
        toggleMenu={toggleMenu}
      />

      {/* Main Content Area */}
      <div className={`transition-all duration-300 ${sidebarCollapsed ? 'ml-16' : 'ml-64'}`}>
        {/* Header Component */}
        <Header
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          notifications={notifications}
          setNotifications={setNotifications}
          showNotifications={showNotifications}
          setShowNotifications={setShowNotifications}
          showProfileDropdown={showProfileDropdown}
          setShowProfileDropdown={setShowProfileDropdown}
          currentUser={currentUser}
        />

        {/* Main Content Component */}
        <NotificationAffiliate
          currentUser={currentUser}
          dashboardStats={dashboardStats}
          brands={brands}
          recentNotifications={recentNotifications}
          notificationsByCountry={notificationsByCountry}
          notificationTypes={notificationTypes}
          notificationTemplates={notificationTemplates}
        />
      </div>
    </div>
  );
};

export default NotificationAffiliateLayout;